import {
    type ReactNode
} from "react";
import {
    Consumer
} from "./Consumer";
import {
    Context
} from "./Host";
import {
    NCoreUIKitLocalize
} from "../../core/hooks";

interface IPortalProps {
    children: ReactNode;
    name?: string;
}

export const Portal = ({
    children,
    name
}: IPortalProps): ReactNode => {
    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    const renderChildren = (): ReactNode => {
        if(direction === NCoreUIKitLocalize.state.direction) {
            return children;
        }

        return <NCoreUIKitLocalize.DirectionProvider
            direction={direction}
        >
            {children}
        </NCoreUIKitLocalize.DirectionProvider>;
    };

    return <Context.Consumer>
        {(manager): ReactNode => {
            return <Consumer
                manager={manager}
                name={name}
            >
                {renderChildren()}
            </Consumer>;
        }}
    </Context.Consumer>;
};
